import type { MinMax } from '../../core/types/min-max.js';
import type {
  AxisId,
  AxisIdToCurrentScaleDomain,
  XYChartAxisInternal,
} from '../types/xy-chart-internals.js';

export function getCurrentDomainMap(axes: XYChartAxisInternal[]) {
  const emptyMap: AxisIdToCurrentScaleDomain = new Map<
    AxisId,
    MinMax | undefined
  >();
  const resultMap = axes.reduce((acc, current) => {
    const axisReversed = current.reversed ? 1 : 0;
    const currentMinMax = current.interactions.current
      ? ({
          min: current.interactions.current[axisReversed],
          max: current.interactions.current[1 - axisReversed],
        } as MinMax)
      : undefined;
    acc.set(current.id, currentMinMax);
    return acc;
  }, emptyMap);

  return resultMap.size ? resultMap : undefined;
}
